function initCountdownWidget() {
  const translatedText = {
    en: ['Days', 'Hours', 'Minutes', 'Seconds'],
    sp: ['Días', 'Horas', 'Minutos', 'Segundos']
  }
  const text = document.location.pathname.includes('/es/') ? translatedText.sp : translatedText.en;
  const countdownWidget = document.createElement('div');
  countdownWidget.id = 'countdown';
  countdownWidget.innerHTML = `
    <span id="days">
      <span>00</span>
      <h2>${text[0]}</h2>
    </span>
    <span id="hours">
      <span>00</span>
      <h2>${text[1]}</h2>
    </span>
    <span id="minutes">
      <span>00</span>
      <h2>${text[2]}</h2>
    </span>
    <span id="seconds">
      <span>00</span>
      <h2>${text[3]}</h2>
    </span>
  `;

  const styleCountdown = () => {
    countdownWidget
    countdownWidget.style.display = 'flex';
    countdownWidget.style.justifyContent = 'center';
    countdownWidget.style.gap = '20px';
    countdownWidget.style.margin = '0 auto'

    const countdownItems = countdownWidget.querySelectorAll('span');
    countdownItems.forEach(item => {
      item.style.display = 'flex';
      item.style.flexDirection = 'column';
      item.style.alignItems = 'center';
      item.style.fontSize = '24px';
      item.style.fontFamily = 'Arial, sans-serif';
    });

    const numbers = countdownWidget.querySelectorAll('span span');
    numbers.forEach(num => {
      num.style.fontSize = '45px';
      num.style.fontWeight = 'bold';
    });

    const days = countdownWidget.querySelectorAll('span h2');
    days.forEach(day => {
      day.style.fontWeight = '500';
    });
  };

  injectCountdown(countdownWidget);
  styleCountdown();
}

function countdownTimer(targetTime) {
  const daysElement = document.querySelector('#days span');
  const hoursElement = document.querySelector('#hours span');
  const minutesElement = document.querySelector('#minutes span');
  const secondsElement = document.querySelector('#seconds span');

  const updateCountdown = () => {
    const currentTime = new Date().getTime();
    const distance = targetTime - currentTime;

    if (distance < 0) {
      clearInterval(interval);
      return;
    }

    const days = Math.max(0, Math.floor(distance / (1000 * 60 * 60 * 24)));
    const hours = Math.max(0, Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
    const minutes = Math.max(0, Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
    const seconds = Math.max(0, Math.floor((distance % (1000 * 60)) / 1000));

    // Ensure all numbers are 2 digits
    const formattedDays = String(days).padStart(2, '0');
    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');

    if (daysElement && hoursElement && secondsElement && minutesElement) {
      daysElement.innerHTML = formattedDays;
      hoursElement.innerHTML = formattedHours;
      minutesElement.innerHTML = formattedMinutes;
      secondsElement.innerHTML = formattedSeconds;
    }
    
  };

  const interval = setInterval(updateCountdown, 1000);
}

function injectCountdown(countdownWidget) {
  const parentElement = document.querySelector('#makeSwitchRichText');

  if (parentElement && parentElement.parentNode) {
    const parentNode = parentElement.parentNode;
    parentNode.appendChild(countdownWidget);
  }
}

async function fetchTargetTime() {
  try {
    const response = await $.ajax({
      url: '/api/CountdownWidget/getTargetTime',
      type: 'GET',
    });
    return response.targetTime;
  } catch (error) {
    console.error('Error fetching target time:', error);
    return '2024-10-15T00:01:00';
  }
}

if (window.location.pathname === '/services/digital-banking/new-olb' || window.location.pathname === '/es/services/digital-banking/new-olb') {
  (async () => {
    const tempTargetTime = await fetchTargetTime();
    const targetTime = new Date(tempTargetTime).getTime();

    initCountdownWidget();
    countdownTimer(targetTime);
  })();
}
